import { render, staticRenderFns } from "./AudioReasonRich.vue?vue&type=template&id=6e20e8f6&scoped=true&"
import script from "./AudioReasonRich.vue?vue&type=script&lang=js&"
export * from "./AudioReasonRich.vue?vue&type=script&lang=js&"
import style0 from "./AudioReasonRich.vue?vue&type=style&index=0&id=6e20e8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e20e8f6",
  null
  
)

export default component.exports